__webpack_require__.p = "/Tech_test_BS/";